import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PaginationType1, DraftContent } from "components/ProfilePage/styled";
import Pagination from "components/Pagination";
import {
  Card,
  CardBody,
  CardImage,
  CardInfo,
  CardTitle,
  CardTags,
  DraftActions,
  CardBodyInfo,
  CardWrapBorder,
} from "styles/MainCards.styled";
import { colors } from "styles/colors";
import Button from "shared/Button";
import { Spinner } from "styles/App.styled";
import { useStateMachine } from "little-state-machine";
import { updateCollection, cleanAddCollection, getImageName } from "helpers";
import Router from "next/router";
import { setDraftCollections, deleteOwnCollection } from "store/recipesReducer/recipesActions";
import { NoImage } from "styles/Preview.styled";
import cloudfront from "helpers/cloudfront";
import { getDraftsCollections, isDraftsCollectionsLoading } from "store/recipesReducer/recipesSelectors";

const OwnDraftsCollection = () => {
  const dispatch = useDispatch();
  const ownDrafts = useSelector(getDraftsCollections);
  const isLoading = useSelector(isDraftsCollectionsLoading);
  const [currentPage, setCurrentPage] = useState(1);
  const { actions } = useStateMachine({
    updateCollection,
    cleanAddCollection,
  });

  const draftsPageRequest = (pagination) => {
    dispatch(setDraftCollections(pagination));
  };

  const toFirstPage = (item) => {
    const pdf = {
      file_type: "pdf",
      file: {
        ref_url: item.collection_pdf_file_url,
        name: item.collection_pdf_file_name,
      },
      id: item.collection_pdf_file_id,
    };
    if (item.paid) actions.updateCollection({ ...item, recipe: [], recipe_paid: item.recipe, pdf });
    else actions.updateCollection({ ...item, recipe_paid: [], pdf });
    Router.push("/add-collection");
  };

  const deleteDraft = (id) => {
    dispatch(deleteOwnCollection(id));
  };

  const handlePage = (page) => setCurrentPage(page);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <DraftContent>
          <CardWrapBorder>
            {ownDrafts.results.map((item) => (
              <Card key={item.id} className="horizontal">
                <CardImage>
                  {item.main_image ? (
                    <img
                      className="cloudfront"
                      src={cloudfront({ href: item.main_image, size: "medium" })}
                      alt={getImageName(item.main_image)}
                    />
                  ) : (
                    <NoImage />
                  )}
                </CardImage>
                <CardBody>
                  <CardBodyInfo>
                    <CardTitle>{item.title}</CardTitle>

                    <CardTags>
                      {item.tags.map((item) => {
                        return <span key={item.id}>{item.name.toLowerCase()},</span>;
                      })}
                    </CardTags>
                    <CardInfo>
                      {item.description && item.description.split("\n").map((val, i) => <p key={i}>{val}</p>)}
                    </CardInfo>
                  </CardBodyInfo>
                  <DraftActions>
                    <Button
                      color={colors.RED}
                      textColor={colors.WHITE}
                      stylType="primary"
                      text="Edit & Publish"
                      onClick={() => toFirstPage(item)}
                    />
                    <Button
                      bdButton={colors.WHITE}
                      color={colors.RED}
                      textColor={colors.WHITE}
                      text="Delete"
                      stylType="default"
                      onClick={() => deleteDraft(item.id)}
                    />
                  </DraftActions>
                </CardBody>
              </Card>
            ))}
          </CardWrapBorder>
          <PaginationType1>
            <Pagination
              handleDraftPage={handlePage}
              _page={currentPage}
              destination={"recipe_manager"}
              stepClick={draftsPageRequest}
              countOfElements={ownDrafts.count}
              isDraft
            />
          </PaginationType1>
        </DraftContent>
      )}
    </>
  );
};

export default OwnDraftsCollection;
